import { Component, OnInit, Output, EventEmitter, HostListener, Injectable, TemplateRef, Input } from '@angular/core';
import { LoaderService } from '../../../shared/providers/loader.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { OfferService } from '../../../shared/providers/offer.service';
import { ToastService } from '../../../shared/providers/toast.service';
import { RequestModel } from '../../../shared/models/RequestModel'
import { IOfferDetailOutputModel } from '../../../shared/models/OfferDetailOutputModel';
import { ValidationService } from '../../../shared/providers/validation.service';
import { PropertyDetailForOffer } from '../../../shared/models/PropertyDetailForOffer';
import { ResultOutputModel } from '../../../shared/models/resultOutputModel';
import { IFileUpload } from '../../../shared/models/fileupload';
import { FileUploadService } from '../../../shared/providers/fileupload.service';
import { CommonService } from '../../../shared/providers/common.service';
import { PropertyManagementService } from '../../../shared/providers/property-management.service';

@Component({
  selector: 'app-property-deal-making',
  templateUrl: './property-deal-making.component.html',
  styleUrls: ['./property-deal-making.component.css']
})
export class PropertyDealMakingComponent implements OnInit {

  constructor(private Loader: LoaderService, private activatedRoute: ActivatedRoute, private modalService: BsModalService, public router: Router, private _offerService: OfferService,
    public authService: AuthenticationService, private _toastService: ToastService, public Validation: ValidationService, private _fileUploadService: FileUploadService, public commonService: CommonService,
    private _propertyManagementService: PropertyManagementService) {

  }
  hasAccess = false;
  @Input() offerGuid: string;
  @Input() propertyId: number;
  offerId: number = 0;
  user: any;
  breadCrumb_Offers_List: string;
  requestModel = {} as RequestModel;
  showActions = false;
  resultOutputModel = {} as ResultOutputModel;
  OfferDetailOutputModel = {} as IOfferDetailOutputModel;
  propertyDetailForOffer = {} as PropertyDetailForOffer;
  disabledAcceptBtn: boolean = false;
  disabledRejectBtn: boolean = false;
  showAccept: boolean = false;
  showEditButton = false;
  isPrincipal = true;
  modalRef: BsModalRef;
  fileExtensionType: string = "document";
  fileExtensionLOIType: string = "LOI";
  fileTypes = '.PDF, .XLSX, .XLS, .DOCX, .DOC, .TXT, .DWG'
  fileUploadType: string = "single";
  clearFiles: number = 0;
  inputFileUploadForLOI = {} as IFileUpload;
  roleId: number = 0;
  isShowNew = false;
  isShowReviewed = false;
  isShowCounterAccepted = false;
  isShowCounterDeclined = false;
  isShowUnderContract = false;
  isShowClosed = false;
  isShowRejected = false;
  isShowCancel = false;
  isShowOfferModified = false;
  isShowDraft = false;
  isShowOfferAccepted = false;
  isShowCountered = false;
  isShowHardContract = false;
  isShowOnHold = false;
  isShowDelete = false;
  isShowResume = false;
  isShowDeclined = false;
  prevPage = 'Deals';
  selectedFiles: string[] = [];
  isBroker: boolean = true;
  showModifyButton: boolean = false;
  buyerOrSeller: string;
  options = [{ name: "Buyer", id: 1 }, { name: "Seller", id: 2 }];
  optionSelected: any;
  openTab = "details";
  showNodata = true;
  isSellerUser = false;
  isfromDealMaking = true;
  ngOnInit() {
    this._propertyManagementService.GetOfferDetailsByPropertyId(this.propertyId).subscribe(res => {
      this.offerGuid = res["Guid"] as any;

      if (this.offerGuid) {
        this.showNodata = false;
        this.activatedRoute.params.subscribe(params => {
          this.user = this.authService.user;
          let accessInputModel =
          {
            Type: 1,
            UserId: this.user.Id,
            Id: null,
            Guid: this.offerGuid
          }

          this.commonService.CheckAccess(accessInputModel).subscribe(response => {
            if (!response) {
              this._toastService.addToast({ title: 'Error Occurred', msg: "You don't have access to the page.", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
              this.hasAccess = false;
              this.router.navigate(['/']);
            }
            else {
              this.hasAccess = true;
            }
          });
        });
        this.optionSelected = 0;
        this.user = this.authService.user;
        this.roleId = this.user.RoleId;

        if (this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.Principal1031)) {
          this.isPrincipal = true;
        }
        else {
          this.isPrincipal = false;
        }
        if (this.authService.IsUserRole(this.authService.UserRole.Broker)) {
          this.isBroker = true;
        }
        else {
          this.isBroker = false;
        }

        this.activatedRoute.params.subscribe(params => {
          ////this.offerGuid = params.id

          this._offerService.getOfferDetails(this.offerGuid).subscribe(response => {
            this.OfferDetailOutputModel = response;
            this.offerId = this.OfferDetailOutputModel.LeadDetailId;
            if (this.OfferDetailOutputModel.ProfilePicPath === undefined || this.OfferDetailOutputModel.ProfilePicPath === null || this.OfferDetailOutputModel.ProfilePicPath.trim().length <= 0) {
              this.OfferDetailOutputModel.ProfilePicPath = '/../../../assets/img/default-profile-img.png'
            }

            if ((this.user.Id == this.OfferDetailOutputModel.PrincipalId) || response.IsDraft) {
              this.showActions = false;
            }
            else {
              this.showActions = true;
            }
            if (this.OfferDetailOutputModel.OfferStatus != 'Rejected' && (this.user.Id === this.OfferDetailOutputModel.PrincipalId
              || (this.OfferDetailOutputModel.CoBrokerId != null && this.user.Id === this.OfferDetailOutputModel.CoBrokerId))) {
              this.showEditButton = true;
            }
            if (this.OfferDetailOutputModel.OfferStatus != 'Rejected' && (this.user.Id === this.OfferDetailOutputModel.PrincipalId
              || (this.isBroker))) {
              this.showModifyButton = true;
            }

            this._offerService.getPropertyDetails(this.OfferDetailOutputModel.PropertyGuid).subscribe(response => {
              this.OfferDetailOutputModel.PropertyImagePath = response.FilePath;
              this.propertyDetailForOffer = response;
              if (this.OfferDetailOutputModel.PropertyImagePath === undefined || this.OfferDetailOutputModel.PropertyImagePath === null || this.OfferDetailOutputModel.PropertyImagePath === "") {
                this.OfferDetailOutputModel.PropertyImagePath = '/../../../assets/img/default-property_1.png'
              }
              if (this.propertyDetailForOffer.PrimaryContactImagePath === undefined || this.propertyDetailForOffer.PrimaryContactImagePath === null || this.propertyDetailForOffer.PrimaryContactImagePath === "") {
                this.propertyDetailForOffer.PrimaryContactImagePath = '/../../../assets/img/default-profile-img.png'
              }
            });
            if (!this.authService.Seller()) {
              this.hideChangeStatusOptions(this.OfferDetailOutputModel.OfferStatusId);
            }
          });
        });
      }
    });
  }
  showBuyerInfoIfAny() {
    let buyerInfo = "";
    if (!this.Validation.IsinValid(this.OfferDetailOutputModel.BuyerFirstName)) {
      buyerInfo += this.OfferDetailOutputModel.BuyerFirstName + " ";
    }
    if (!this.Validation.IsinValid(this.OfferDetailOutputModel.BuyerLastName)) {
      buyerInfo += this.OfferDetailOutputModel.BuyerLastName;
    }
    if (!this.Validation.IsinValid(buyerInfo)) {
      return "on behalf of " + buyerInfo;
    }
    return buyerInfo;
  }
  comments: string;
  //filesCollection = [];
  //latestId = 0;
  //selectedFilesListEmitter(selectedFilesListEmitter: string[]) {
  //    this.selectedFiles = selectedFilesListEmitter;

  //}
  viewProperty(guid) {
    this.router.navigateByUrl('viewproperty/' + guid)
  }

  viewCounterOffer(guid: string) {
    if (this.OfferDetailOutputModel.OfferStatusId == 466 || this.OfferDetailOutputModel.OfferStatusId == 467) {
      this._offerService.CheckNewOfferExistOnCancelledOffer(this.OfferDetailOutputModel.PrincipalId, this.OfferDetailOutputModel.PropertyGuid).subscribe(res => {
        if (res) {
          this._toastService.addToast({
            title: 'Error', msg: "Cannot change the status. Another offer from the same ID is progressing.", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
          })
        }
        else {
          this.router.navigate(['/counter-offer/' + guid]);
        }
      });
    }
    else {
      this.router.navigate(['/counter-offer/' + guid]);
    }
  }
  onModify() {
    this.router.navigate(["/place-offer/" + this.OfferDetailOutputModel.PropertyGuid + "/" + this.offerGuid + "/offer-detail@@" + this.offerGuid]);

  }
  classToBind = "tabstyle2 offerdetailstab-padding";
  showBadge(Status: boolean) {
    //if (Status) {
    //    this.classToBind = "tabstyle2 offerdetailstab-padding taskhighlight";
    //}
    //else {
    //    this.classToBind = "tabstyle2 offerdetailstab-padding";
    //}
  }

  openModalForCounterAccept(template: TemplateRef<any>, classes) {
    if (this.OfferDetailOutputModel.OfferStatusId == 466 || this.OfferDetailOutputModel.OfferStatusId == 467) {
      this._offerService.CheckNewOfferExistOnCancelledOffer(this.OfferDetailOutputModel.PrincipalId, this.OfferDetailOutputModel.PropertyGuid).subscribe(res => {
        if (res) {
          this._toastService.addToast({
            title: 'Error', msg: "Cannot change the status. Another offer from the same ID is progressing.", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
          })
        }
        else {
          this.showAccept = true;
          this.modalRef = this.modalService.show(template, { class: classes });
        }
      });
    }
    else {
      this.showAccept = true;
      this.modalRef = this.modalService.show(template, { class: classes });
    }
  }
  closeModal() {
    this.modalRef.hide();

  }

  openModalForCounterReject(template: TemplateRef<any>, classes) {
    this.modalRef = this.modalService.show(template, { class: classes });
    this.showAccept = false;
  }
  changeOfferStatus(statusId: number) {
    this.requestModel.Guid = this.offerGuid;
    this.requestModel.StatusId = statusId;
    this.requestModel.UserId = this.user.Id;

    if (this.OfferDetailOutputModel.OfferStatusId == 466 || this.OfferDetailOutputModel.OfferStatusId == 467) {
      this._offerService.CheckNewOfferExistOnCancelledOffer(this.OfferDetailOutputModel.PrincipalId, this.OfferDetailOutputModel.PropertyGuid).subscribe(res => {
        if (res) {
          this._toastService.addToast({
            title: 'Error', msg: "Cannot change the status. Another offer from the same ID is progressing.", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
          })
        }
        else {
          this.offerStatusChange();
        }
      });
    }
    else {
      this.offerStatusChange();
    }
  }

  private offerStatusChange() {
    this._offerService.changeOfferStatusUsingGuid(this.requestModel).subscribe(response => {
      if (response) {
        this._toastService.addToast({ title: 'Success', msg: 'Offer status changed Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
        //this._offerService.getOfferDetails(this.offerGuid).subscribe(response => {
        //    this.OfferDetailOutputModel.OfferStatus = response.OfferStatus;
        //});
        //location.reload();
        this.router.navigateByUrl("redirect?url=" + encodeURIComponent(this.router.url), { skipLocationChange: true });
        //this.router.navigateByUrl("redirect?url=" + this.router.url);
      }
      else {
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Operation failed', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
    });
  }


  hideChangeStatusOptions(statusId) {
    if (this.authService.Broker() || this.authService.Admin() || this.authService.SuperAdmin() || this.isSellerUser) {
      if (statusId == 451 || statusId == 461) {
        this.isShowOfferAccepted = true;
        this.isShowDeclined = true;
        this.isShowCancel = true;
        this.isShowHardContract = true;
        this.isShowUnderContract = true;
        this.isShowCountered = true;
      }
      if (statusId == 460) {
        this.isShowNew = true;
        this.isShowCancel = true;
        this.isShowHardContract = true;
        this.isShowUnderContract = true;
        this.isShowCountered = true;
        this.isShowClosed = true;
      }
      if (statusId == 455) {
        this.isShowNew = true;
        this.isShowCancel = true;
        this.isShowHardContract = true;
        this.isShowOfferAccepted = true;
        this.isShowCountered = true;
        this.isShowClosed = true;
      }

      if (statusId == 462 || statusId == 458) {
        this.isShowNew = true;
        this.isShowCancel = true;
        this.isShowUnderContract = true;
        this.isShowOfferAccepted = true;
        this.isShowCountered = true;
        this.isShowClosed = true;

      }

      if (statusId == 456) {
        this.isShowNew = true;
        this.isShowCancel = true;
        this.isShowUnderContract = true;
        this.isShowOfferAccepted = true;
        this.isShowCountered = true;
        this.isShowHardContract = true;
      }
      if (statusId == 451 || statusId == 461 || statusId == 466 || statusId == 467) {
        this.isShowOfferAccepted = true;
        this.isShowNew = true;
        this.isShowHardContract = true;
        this.isShowUnderContract = true;
        this.isShowCountered = true;
      }
    }

    if ((this.authService.Principal() || this.authService.Principal1031() || this.authService.ExternalBroker()) && !this.isSellerUser) {
      //if (statusId == 455 || statusId == 462 || statusId == 460 || statusId == 456) {
      //    this.isShowCancel = true;
      //}
      if (statusId == 451) {
        this.isShowCountered = true;
        // this.isShowCancel = true;
      }

      if (statusId == 461) {
        this.isShowOfferAccepted = true;
        this.isShowCountered = true;
      }
    }
    //if (statusId == 451 || statusId == 458 || statusId == 465) {
    //    this.isShowOfferAccepted = true;
    //    this.isShowRejected = true;
    //    this.isShowDelete = true;
    //    this.isShowOnHold = true;
    //    this.isShowCountered = true;
    //}
    //else if (statusId == 461) {
    //    this.isShowOfferAccepted = true;
    //    this.isShowRejected = true;
    //    this.isShowCountered = true;

    //}
    //else if (statusId == 457) {
    //    this.isShowOnHold = true;
    //}
    //else if (statusId == 460) {
    //    this.isShowHardContract = true;
    //    this.isShowUnderContract = true;
    //    this.isShowClosed = true;
    //    this.isShowDelete = true;
    //    this.isShowOnHold = true;

    //}
    //else if (statusId == 455) {

    //    this.isShowHardContract = true;
    //    this.isShowClosed = true;
    //    this.isShowDelete = true;
    //    this.isShowOnHold = true;

    //}
    //else if (statusId == 462) {

    //    this.isShowUnderContract = true;
    //    this.isShowClosed = true;
    //    this.isShowDelete = true;
    //    this.isShowOnHold = true;

    //}
    //else if (statusId == 463) {
    //    this.isShowDelete = true;
    //    this.isShowResume = true;

    //}

  }

  changeTitle(event, tabName: string) {
    let url = this.Validation.paramReplace('opentab', this.router.url, tabName)
    this.router.navigateByUrl(url + "?opentab=" + tabName);
  }
  offerAccepted(event) {
    this.router.navigateByUrl("redirect?url=" + encodeURIComponent(this.router.url), { skipLocationChange: true });

  }

}
